import {showMessage} from "@app/constants/Messages";

export const validateEmployerInput = (employer) => {
    if (!employer.name || !employer.brief_name) {
        showMessage("Vui lòng nhập đầy đủ name và brief name của employer.");
        return false
    }
    if (!employer.mst) {
        showMessage("Vui lòng nhập mã số thuế.");
        return false
    }
    return true;
}
